import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {Component, ViewEncapsulation} from "@angular/core";
import {AlertViewModalModel} from "../../_models/AlertViewModalModel";
import {MK_ALERT_VIEW_MODAL_MODEL} from "../../_controllers/IAlertViewModalController";
import {ModalHeaderView} from "../../../modal-header/_views/modal-header.view";
import { AlertStatus } from "../../../../interfaces/domain/alert/AlertStatus";


@Component({
  selector: 'link-alert-view-modal-header',
  templateUrl: './alert-view-modal-header.view.html',
  styleUrls: ['./alert-view-modal-header.view.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AlertViewModalHeaderView extends ModalHeaderView {

  protected readonly model: AlertViewModalModel;

  protected readonly AlertStatus = AlertStatus;

  constructor(dialogService: DialogService,
              dialogRef: DynamicDialogRef) {
    super(dialogService, dialogRef);
    this.model  = this.getController().getModel(MK_ALERT_VIEW_MODAL_MODEL);
  }
}
